import { defineComponent as _defineComponent } from 'vue'
import { BendShiftStatisticsData } from '@/models/Charts/chartsData';
import { decimalFormatter } from '@/utils/number';
import TableWithActions2 from '../tableWithActions/TableWithActions2.vue';
import { isEmpty } from '@/utils/misc';
import { createSortByField, sortedDetails } from './shiftStatisticsUtils';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'BendProductivityTable',
  props: {
    data: null,
    loading: { type: Boolean },
    isFetchingForTheFirstTime: { type: Boolean }
  },
  setup(__props: any) {



const { t } = useI18n();

return { __sfc: true,t, decimalFormatter, TableWithActions2, isEmpty, createSortByField, sortedDetails }
}

})